import { Box, Flex } from '@modusign/design-system';
import { forwardRef } from 'react';

interface UsageProgressBarProps {
  limit: number;
  usage: number;
}

const UsageProgressBar = forwardRef<HTMLDivElement, UsageProgressBarProps>(
  ({ limit, usage }, ref) => {
    return (
      <Flex alignItems="center" height="20px" ref={ref} width="100%">
        <Box
          backgroundColor={limit === Infinity ? 'pureYellow900' : 'statusBackgroundNeutralBase'}
          borderRadius="4px"
          height="4px"
          width="100%"
        >
          {limit !== Infinity && (
            <Box
              backgroundColor="pureYellow900"
              borderRadius={`4px ${limit !== usage ? '0px 0px' : '4px 4px'} 4px`}
              height="4px"
              width={`${limit === 0 ? 100 : Math.max(0, ((limit - usage) / limit) * 100)}%`}
            />
          )}
        </Box>
      </Flex>
    );
  }
);

export default UsageProgressBar;
